module.exports = __webpack_public_path__ + "fonts/NeulisAlt-Bold.7e6ee2b.woff2";